/* Publish by EComposer at 2026-10-20 10:11:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qv7l01y4e7"]=  window.__ectimmers["ecom-qv7l01y4e7"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qv7l01y4e7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qv7l01y4e7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9w6lnwsx8fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9w6lnwsx8fk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-od445jzxyca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-od445jzxyca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xlzarsgzd3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xlzarsgzd3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kvcbze7lp1r"]=  window.__ectimmers["ecom-kvcbze7lp1r"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-kvcbze7lp1r"]["kpwhm9jej"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-kvcbze7lp1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kvcbze7lp1r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}